import { defineStore } from 'pinia'
import { createRequestClubActiveCard } from 'www/vue_components/common/Club/api'
import { CLUB_DISCOUNT } from 'www/vue_components/common/Club/constants'
import { getUserClubCardData } from 'www/vue_components/common/Club/components/core/ClubCardGetting/api'
import {
  getOfferData,
  getCouponData,
  getInitClubStatusData,
} from 'www/vue_components/common/AppointmentPage/interfaces'
import { APPOINTMENT_TYPES } from 'www/constants'
import { PAYMENT_TYPES } from 'www/vue_components/common/AppointmentPage/constants'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'
// eslint-disable-next-line import/no-cycle
import useDoctorDataStore from 'www/vue_components/common/AppointmentPage/stores/useDoctorDataStore'
// eslint-disable-next-line import/no-cycle
import useAppointmentDataStore from 'www/vue_components/common/AppointmentPage/stores/useAppointmentDataStore'
import usePreliminaryConsultationStore from 'www/vue_components/common/AppointmentPage/stores/usePreliminaryConsultationStore'

const useClubDataStore = defineStore('clubDataStore', {
  state: () => ({
    clubStatusData: getInitClubStatusData(),
    offerData: getOfferData(),
    couponData: getCouponData(),
    selectedPaymentType: null,
    isClubModalVisible: false,
    isInitClubViewVisibilityAllowed: true,
    isAcceptedOptionNonRefundable: false,
    userClubData: window.USER.club,
  }),
  getters: {
    isInitClubViewVisible() {
      return this.isInitClubViewVisibilityAllowed && !!this.clubStatusData.couponData?.id
    },
    isClubPaymentTypeSelected() {
      return this.selectedPaymentType === PAYMENT_TYPES.club
    },
    isClubSelectTypePaymentVisible() {
      const doctorDataStore = useDoctorDataStore()
      const appointmentDataStore = useAppointmentDataStore()

      return Boolean(
        appointmentDataStore.appointmentRegistrationTypes.isDirect
                && doctorDataStore.selectedWorkplace.isInClub
                && this.selectedPaymentType,
      )
    },
    isClubAvailable() {
      const lpuDataStore = useLpuDataStore()
      const preliminaryConsultationStore = usePreliminaryConsultationStore()

      // TODO: убрать проверку, когда добавится клуб для консультаций
      if (preliminaryConsultationStore.isPreliminaryConsultation) {
        return false
      }

      return lpuDataStore.lpuData.isEnabledClubDiscount && this.userClubData.isInClub
    },
  },
  actions: {
    updateOfferData(payload) {
      this.offerData = {
        ...this.offerData,
        ...payload,
      }
    },
    updateCouponData(payload) {
      this.couponData = {
        ...this.couponData,
        ...payload,
      }
    },
    updateUserClubData(payload) {
      this.userClubData = {
        ...this.userClubData,
        ...payload,
      }
    },
    updateStateSelectedPaymentType(payload) {
      this.selectedPaymentType = payload
    },
    updateStateIsClubModalVisible(payload) {
      this.isClubModalVisible = payload
    },
    updateStateIsInitClubViewVisibilityAllowed(payload) {
      this.isInitClubViewVisibilityAllowed = payload
    },

    setStateSelectedPaymentType(paymentType) {
      const appointmentDataStore = useAppointmentDataStore()

      this.updateStateSelectedPaymentType(paymentType)

      const isClubSelected = paymentType === PAYMENT_TYPES.club && this.isClubSelectTypePaymentVisible
      const isLpuSelected = (paymentType === PAYMENT_TYPES.lpu && this.isClubSelectTypePaymentVisible)
        || !this.isClubSelectTypePaymentVisible

      if (isClubSelected) {
        appointmentDataStore.updateInitAdditionalPlaceType(APPOINTMENT_TYPES.club)
      } else if (isLpuSelected) {
        appointmentDataStore.updateInitAdditionalPlaceType(APPOINTMENT_TYPES.lpu)
      }
    },
    async requestOfferData() {
      const doctorDataStore = useDoctorDataStore()

      if (!doctorDataStore.selectedWorkplace.isInClub) {
        return
      }

      try {
        const offerData = await createRequestClubActiveCard({
          wpID: doctorDataStore.selectedWorkplace.id,
        })

        this.updateOfferData({
          lpuPrice: offerData.club_lpu_price,
          couponPrice: offerData.club_coupon_price,
          cardDateEnd: offerData.club_card_dt_end,
          cardPrice: offerData.club_card_price,
          totalPrice: offerData.club_offer_total_price,
          cardLifetimeMonths: offerData.CLUB_CARD_LIFETIME_MONTHS,
          clubDiscount: CLUB_DISCOUNT,
        })
      } catch { /* Empty */ }
    },
    async requestUserClubData() {
      try {
        const userClubData = await getUserClubCardData()

        this.updateUserClubData(userClubData)
      } catch { /* Empty */ }
    },
  },
})

export default useClubDataStore
